import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { FormGroupWrapper } from 'core/elements';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { PricingProfilePricingType } from 'pricing/enums';
import { IPricingProfileForm } from 'pricing/types';

interface IProps {
  type: PricingProfilePricingType;
  isOpen: boolean;
  onClose?: () => void;
  onSubmit?: (reset?: UseFormReset<IPricingProfileForm>) => (data: IPricingProfileForm) => void;
  level?: number;
  defaultName?: string;
  withValidityDates: boolean;
}

export const AddPricingProfileFormFields = ({
  type,
  isOpen,
  onClose,
  onSubmit,
  level,
  defaultName,
  withValidityDates,
}: IProps) => {
  const { watch } = useFormContext();

  const { t } = useTranslation();

  const title =
    type === PricingProfilePricingType.PRICING
      ? t('titleCreatePricingProfile')
      : t('titleCreateCostingProfile');

  return (
    <Form
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      submitBtnLabel={t('buttonLabelCreate')}
      cancelBtnLabel={t('buttonLabelCancel')}
      onSubmit={onSubmit}
      level={level}
    >
      <FormField
        name="name"
        type={InputType.TEXT_INPUT}
        inputProps={{
          label: t('labelName'),
          defaultValue: defaultName,
          required: true,
        }}
      />

      <FormField
        name="agreementId"
        type={InputType.TEXT_INPUT}
        inputProps={{
          label: t('labelAgreementId'),
        }}
      />

      {withValidityDates && (
        <FormGroupWrapper name="validityDates">
          <FormField
            name="startDate"
            type={InputType.DATE_INPUT}
            inputProps={{
              label: t('labelStartDate'),
              maxDate: watch('endDate'),
            }}
          />
          <FormField
            name="endDate"
            type={InputType.DATE_INPUT}
            inputProps={{
              label: t('labelEndDate'),
              minDate: watch('startDate'),
            }}
          />
        </FormGroupWrapper>
      )}

      <FormField
        name="shareAccess"
        type={InputType.CHECKBOX}
        inputProps={{
          label: t('messagePricingProfileShareAccess'),
        }}
      />
    </Form>
  );
};
